import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Checkbox } from 'semantic-ui-react';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { toggleCalendar, toggleCalendarAll } from '../state/letters/actions';

class MBEGridContainer extends Component {
  getIsChecked = id => {
    return this.props.selectedCalendars.includes(id);
  };

  getIsAllChecked = () => {
    return this.props.selectedCalendars.length === this.props.calendars.length;
  };

  render() {
    const headerStyle = {
      textAlign: 'left',
    };

    return (
      <ReactTable
        data={this.props.data}
        minRows={4}
        defaultFilterMethod={caseInsensitiveFilter}
        showPagination={false}
        columns={[
          {
            Header: () => {
              return (
                <div style={{ paddingTop: '5px' }}>
                  {
                    <Checkbox
                      checked={this.getIsAllChecked()}
                      onClick={(e, data) => {
                        this.props.toggleCalendarAll(data.checked);
                      }}
                    />
                  }
                </div>
              );
            },
            accessor: 'Checked',
            resizable: false,
            sortable: true,
            maxWidth: 50,
            Cell: ({ original }) => {
              return (
                <div style={styles.checkboxCell}>
                  <Checkbox
                    checked={this.getIsChecked(original.Id)}
                    onClick={(e, data) => {
                      this.props.toggleCalendar(data.checked, original.Id);
                    }}
                  />
                </div>
              );
            },
          },
          {
            Header: ({ data }) => {
              return (
                <span style={{ paddingLeft: '10px' }}>School Calendar</span>
              );
            },
            accessor: 'Description',
            filterable: true,
            headerStyle: headerStyle,
          },
          {
            Header: 'Meal Benefit Expiration Date',
            accessor: 'ExpirationDate',
            minWidth: 40,
            filterable: true,
            style: {
              textAlign: 'center',
            },
          },
        ]}
        style={{
          height: '200px', // This will force the table body to overflow and scroll, since there is not enough room
          marginTop: 0,
        }}
      />
    );
  }
}

const styles = {
  checkboxCell: {
    textAlign: 'center',
  },
};

const mapStateToProps = state => {
  const { report } = state.MBENotificationLettersState;

  return {
    calendars: report.calendars,
    selectedCalendars: report.selectedCalendars,
  };
};

export const MBEGrid = withRouter(
  connect(mapStateToProps, { toggleCalendar, toggleCalendarAll })(
    MBEGridContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/mbenotification/components/MBEGrid.js